(() => {
  'use strict';
  const videoUrl = 'https://www.youtube-nocookie.com/embed/LOGzaDCDhlk?controls=1&rel=0&playsinline=1';

  function initialise(root) {
    if (root.dataset.rsInitialised === 'true') return;
    const player = root.querySelector('[data-rs-player]');
    const playButton = root.querySelector('[data-rs-play]');
    if (!player || !playButton) return;
    root.dataset.rsInitialised = 'true';
    playButton.hidden = false;

    playButton.addEventListener('click', () => {
      if (player.querySelector('iframe')) return;
      const iframe = document.createElement('iframe');
      iframe.src = videoUrl;
      iframe.title = "Christine Fischer's story: movement, treatment and motherhood";
      iframe.width = '1280';
      iframe.height = '720';
      iframe.allow = 'accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.setAttribute('aria-describedby', 'rs-film-caption');
      // No player request is made until activation. Playback uses YouTube's own controls.
      player.replaceChildren(iframe);
      iframe.focus();
    });
  }

  document.querySelectorAll('.rs').forEach(initialise);
  // Reinitialise only this section when Shopify's theme editor reloads it.
  document.addEventListener('shopify:section:load', (event) => {
    if (!(event.target instanceof Element)) return;
    event.target.querySelectorAll('.rs').forEach(initialise);
  });
})();
